import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { setBurgerIsClose } from "../../redux/BurgerSlice/BurgerSlice";
import ArrowBlue from "../../assets/icons/ArrowBlue.png";
import "./Burger.css";
import { navArr, navArrRu, } from "../../utils/navArr";

const texts = {
  ua: {
   production: "Продукція",
   aboutUsProduction: "Виробництво",
   aboutUsPastoral: "Pastoral",
   aboutUsMumulya: "Мумуля",
   recipes: "Рецепти",
   blog: "Блог",
   cooperation: "Співпраця",
   contacts: "Контакти",
   back: "< Назад",
  },
  ru: {
    production: "Продукция",
    aboutUsProduction: "Производство",
    aboutUsPastoral: "Pastoral",
    aboutUsMumulya: "Мумуля",
    recipes: "Рецепты",
    blog: "Блог",
    cooperation: "Сотрудничество",
    contacts: "Контакты",
    back: "< Назад",
  },
};

const Burger = () => {
  const location = useLocation();
  const currentLang = location.pathname.startsWith("/ru") ? "ru" : "ua";
  const langPrefix = currentLang === "ru" ? "/ru" : "";
  const t = texts[currentLang];
  const dispatch = useDispatch();
  const isActive = useSelector((state) => state.burger.isBurgerActive);
  const [isSecondLevelBurgerActive, setIsSecondLevelBurgerActive] =
    useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const currentNavArr = currentLang === "ru" ? navArrRu : navArr;


  // const handleSecondLevelMenuOpen = () => {
  //   setIsSecondLevelBurgerActive(true);
  // };

  const handleSecondLevelMenuOpen = (category) => {
    setActiveCategory(category);
    setIsSecondLevelBurgerActive(true);
  };
  const handleSecondLevelMenuClose = () => {
    setIsSecondLevelBurgerActive(false);
    setActiveCategory(null);
  };

  const handleBurgerClose = () => {
    dispatch(setBurgerIsClose());    
  };

  return (
    <div className={`burger__menu ${isActive ? "active" : ""}`}>
      <div className={`burger__overlay`}>
        <div className="burger__body">
          <div
            onClick={handleSecondLevelMenuOpen}
            className={`burger__item-catalog mont-r`}
          >
           {t.production}
            <img
              src={ArrowBlue}
              alt="перейти до каталогу товарів"
              className="arrow__mobile"
            />
          </div>
          <Link
            onClick={handleBurgerClose}
            className={`burger__link  mont-r`}
            to={`${langPrefix}/about-us/production/`}
          >
            {t.aboutUsProduction}
          </Link>
          <Link
            onClick={handleBurgerClose}
            className={`burger__link  mont-r`}
            to={`${langPrefix}/about-us/pastoral/`}
          >
            {t.aboutUsPastoral}
          </Link>
          <Link
            onClick={handleBurgerClose}
            className={`burger__link  mont-r`}
            to={`${langPrefix}/about-us/mumulya/`}
          >
            {t.aboutUsMumulya}
          </Link>
          <Link
            onClick={handleBurgerClose}
            className={`burger__link  mont-r`}
            to={`${langPrefix}/recipes/`}
          >
            {t.recipes}
          </Link>
          <Link
            onClick={handleBurgerClose}
            className={`burger__link  mont-r`}
            to={`${langPrefix}/blog/`}
          >
            {t.blog}
          </Link>
          <Link
            onClick={handleBurgerClose}
            className={`burger__link  mont-r`}
            to={`${langPrefix}/cooperation/`}
          >
            {t.cooperation}
          </Link>
          <Link
            onClick={handleBurgerClose}
            className={`burger__link mont-r`}
            to={`${langPrefix}/contacts/`}          >
            {t.contacts}
          </Link>
        </div>

        <div
          className={`burger__body-second ${
            isSecondLevelBurgerActive ? "active" : ""
          }`}
        >
          <div
            onClick={handleSecondLevelMenuClose}
            className={`burger__body-second-back  mont-r`}
          >
            
            <span>{t.back}</span>{" "}
            <span>
               {t.production}
            </span>
          </div>

          {activeCategory &&
            currentNavArr.map((category, idx) => (
              <Link
                key={idx}
                onClick={handleBurgerClose}
                to={category.path}
                className={`burger__item-catalog mont-r`}
              >
                {category.title}{" "}
               
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Burger;
